import useAxios from "services/useAxios.tsx";
import { useEffect, useState } from "react";
import { TimeStampToJalali } from "utils/helperFunctions";
import { NavLink } from "react-router-dom";
import Pagination from "rc-pagination";
import Loader from "Components/kits/Loader/Loader.tsx";
import { MdOutlineList ,MdOutlineCalendarMonth,MdOutlineToday  } from "react-icons/md";
import { BsCalendarWeek } from "react-icons/bs";

export default function Visit() {
  const { execute: getVisitsApi } = useAxios("api/get_visits");
  const { execute: getVisitReportApi } = useAxios("api/visit_report");

  const [visitList, setVisitList] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    count: 20,
    total: 0,
  });
  const [report, setReport] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function loadPage() {
      setIsLoading(true);
      await getVisitsApi({
        page: pagination?.page,
        count: pagination?.count,
      }).then((result) => {
        setVisitList(result?.result);
        setPagination((prev) => ({ ...prev, total: result?.total }));
        setIsLoading(false);
      });
      await getVisitReportApi().then(result=>{
        setReport(result?.result)
      })
    }
    loadPage();
  }, [pagination?.page]);
  return isLoading ? (
    <div
      className="w-100 d-flex align-items-center justify-content-center"
      style={{ height: "50vh" }}
    >
      <Loader width={40} />
    </div>
  ) : (
    <div>
      <div className="d-flex flex-wrap justify-content-center">
        <div className="d-flex flex-column align-items-center justify-content-around bg-bk-02 color-yl-04 wd-180 he-90 rd-10 mr-10">
          <div className="d-flex align-items-center font-14-700">
            <MdOutlineList style={{margin:2,width:24,height:24}}/>
            <span>کل</span>
          </div>

          <div>
            <span className=" font-18-700">{report?.total}</span>
          </div>
        </div>
        <div className="d-flex flex-column align-items-center justify-content-around bg-bk-02 color-yl-04 wd-180 he-90 rd-10 mr-10">
          <div className="d-flex align-items-center font-14-700">
            <MdOutlineCalendarMonth  style={{margin:2,width:24,height:24}}/>
            <span>30 روز گذشته</span>
          </div>

          <div>
            <span className=" font-18-700">{report?.month}</span>
          </div>
        </div>
        <div className="d-flex flex-column align-items-center justify-content-around bg-bk-02 color-yl-04 wd-180 he-90 rd-10 mr-10">
          <div className="d-flex align-items-center font-14-700">
            <BsCalendarWeek style={{margin:2,width:20,height:20}}/>
            <span>7 رزو گذشته</span>
          </div>

          <div>
            <span className=" font-18-700">{report?.week}</span>
          </div>
        </div>
        <div className="d-flex flex-column align-items-center justify-content-around bg-bk-02 color-yl-04 wd-180 he-90 rd-10 mr-10">
          <div className="d-flex align-items-center font-14-700">
            <MdOutlineToday style={{margin:2,width:24,height:24}}/>
            <span>24 ساعت گذشته</span>
          </div>

          <div>
            <span className=" font-18-700">{report?.day}</span>
          </div>
        </div>
      </div>

      <div className="d-flex flex-wrap">
        {visitList?.map((value, index) => (
          <div className="col-12 col-lg-6">
            <div className="d-flex flex-wrap m-2 ">
              <div
                className=" font-12-500 p-2 flex-grow-1 rounded text-center "
                style={{
                  minWidth: 120,
                  maxWidth: 220,
                  border:
                    index % 2 == 0 ? "1px solid navy" : "1px solid maroon",
                }}
              >
                <div className="fw-bold border-bottom pb-1">زمان بازدید</div>
                <div className="pt-1">
                  {TimeStampToJalali(
                    parseInt(value?.mtm) * 1000,
                    "hh:mm , YYYY/MM/DD"
                  )}
                </div>
              </div>
              <div
                className=" font-12-500 p-2 flex-grow-1 rounded text-center "
                style={{
                  minWidth: 130,
                  maxWidth: 220,
                  border:
                    index % 2 == 0 ? "1px solid navy" : "1px solid maroon",
                }}
              >
                <div className="border-bottom pb-1">صفحه بازدید</div>
                <div className="pt-1">
                  <NavLink
                    to={value?.route}
                    target="_blank"
                    className={"text-decoration-none text-primary"}
                  >
                    {value?.title}
                  </NavLink>
                </div>
              </div>
              <div
                className=" font-12-500 p-2 flex-grow-1 rounded text-center"
                style={{
                  border:
                    index % 2 == 0 ? "1px solid navy" : "1px solid maroon",
                }}
              >
                <div className="border-bottom pb-1">کاربر بازدید کننده</div>
                <div className="pt-1">
                  {value?.mobile == null ? "ناشناس" : value?.fname}&nbsp;
                  {value?.lname}
                  {value?.mobile != null ? `(${value?.mobile})` : ""}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <Pagination
        className="px-1 text-center my-4"
        total={pagination?.total}
        pageSize={pagination?.count}
        showTitle={false}
        current={pagination?.page}
        showLessItems={true}
        onChange={(newPage) => {
          setPagination((prev) => ({ ...prev, page: newPage }));
        }}
      />
    </div>
  );
}
